import { type ResultOf } from '@graphql-typed-document-node/core'
import { useMutation, type UseMutationOptions } from '@tanstack/react-query'

import { graphql } from '~/gql'
import { useGraphQLRequest } from '~/hooks/useGraphQLRequest'

import { useSurveyId } from './useSurveyId'

const document = graphql(`
  mutation SurveySettingsPage_RemoveSurvey($surveyId: ID!) {
    removeSurvey(id: $surveyId) {
      result
    }
  }
`)
type Data = ResultOf<typeof document>

export const useRemoveSurveyMutation = (
  options: Omit<
    UseMutationOptions<Data, unknown, void, unknown>,
    'mutationFn'
  > = {},
) => {
  const graphQLRequest = useGraphQLRequest()
  const surveyId = useSurveyId()

  return useMutation({
    mutationFn: () => graphQLRequest({ document, variables: { surveyId } }),
    ...options,
  })
}
